import React from 'react';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { includes } from 'lodash';
import * as searchActions from '../actions/search';
import * as customerActions from '../actions/customer';
import * as authActions from '../actions/auth';
import * as merchantActions from '../actions/merchant';
import * as planActions from '../actions/plan';
import Jumbotron from './Jumbotron';
import AuthenticationModal from './User/AuthenticationModal';
import ClaimNotifyModal from './User/ClaimNotifyModal';
import MarketingCard from './Card/MarketingCard';

import { Events } from 'ui-utilities';

const dontRedirect = ['/search', '/verify'];

export class Landing extends React.Component {
  componentWillMount() {
    if (this.props.verify) {
      this.props._merchant.validateClaim();
    }

    this.sendToDashboard(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.sendToDashboard(nextProps);
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    Events
      .provide('kissmetrics', true)
      .log(
        'record',
        'Merchant Landing Page View', { 
          'User Location': this.props.customer.get('location').get('place_name')
        });
  }

  sendToDashboard = props => {
    if (props.auth.get('user').get('isLoggedIn') && !includes(dontRedirect, props.location.pathname)) {
      return push('/dashboard');
    }
  }

  claimed = () => {
    const { entities, search } = this.props;

    const merchant = entities
      .get('merchant')
      .find(m => m.vendor_id === search.get('selectedMerchantId'));

    if (merchant && merchant.vendor.get('claimed')) return true;
    return false;
  }

  render() {
    const marketingCards = [
      {
        img: "marketing-card-bon-appetit.jpg",
        headline: "We know your value can't be contained in 5 stars.",
        paragraphs: [
          "Localvores trade cookie-cutter convenience for the thrill of discovery.",
          "Your profile should make an impression. It should tell your story."
        ]
      },
      {
        img: "marketing-card-mandolin.jpg",
        headline: "We believe in the power of connection.",
        paragraphs: [
          "Show your existing food source connections and find new ones using the tools we provide.",
          "Reach your regulars, and be discovered by people who care about what you're doing."
        ]
      },
      {
        img: "marketing-card-berries.jpg",
        headline: "We're inviting everyone to the table.",
        paragraphs: [
          "Eating seasonally isn't possible without the farmers & producers who coax bounty from tiny seeds to tables.",
          "That's why Localvore is free for farms. Always."
        ]
      }
    ];

    return (
      <div className="dashboard">
        {!this.claimed() && 
          <AuthenticationModal {...this.props} />}

        {!this.props.verify && 
          <Jumbotron {...this.props} />}

        {this.claimed() &&
          <ClaimNotifyModal {...this.props} />}

        <div className="container">
          <div className="row">
            <div className="col-12">
              <p className="text-center header-text">
                3 Reasons to Choose <span>Localvore</span>
              </p>
            </div>
          </div>

          <div className="row marketing-content">
            <div className="col-lg-3">
              <p>
                We want to help people discover the best, wherever they are.
              </p>
              <hr className="w-25 orange" />
              <p className="proposition">
                We exist for the love of local.
              </p>
            </div>

            {marketingCards.map((card, i) => (
              <div key={i} className="col-lg-3">
                <MarketingCard
                  {...this.props}
                  img={card.img}
                  headline={card.headline}
                  paragraphs={card.paragraphs}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    auth: state.auth,
    entities: state.entities,
    search: state.search,
    customer: state.customer,
    merchant: state.merchant,
    verify: ownProps.verify
  };
}

function mapDispatchToProps(dispatch) {
  return {
    _auth: bindActionCreators(authActions, dispatch),
    _customer: bindActionCreators(customerActions, dispatch),
    _merchant: bindActionCreators(merchantActions, dispatch),
    _plan: bindActionCreators(planActions, dispatch),
    _search: bindActionCreators(searchActions, dispatch)
  };
}

export const LandingContainer = connect(mapStateToProps, mapDispatchToProps)(
  withRouter(Landing)
);



// WEBPACK FOOTER //
// ./src/components/Landing.js